import React from "react";

const VerificationPopup = ({ messages, onClose }) => {
    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white shadow-lg p-6 text-center">
                <h4 className="w-full text-sm font-semibold text-ellipsis text-gray-800 mb-3">The listed products don't fulfill the order requirements. Please check and revise.</h4>
                <ul className="text-left text-gray-600 space-y-2 mb-6">
                    {messages.map((message, index) => (
                        <li key={index} className="list-disc ml-4" style={{fontSize: "0.8rem"}}>
                            {message}
                        </li>
                    ))}
                </ul>
                <div className="flex justify-end">
                    <button
                        className="bg-red-600 hover:bg-red-600 text-white font-semibold py-1.5 px-4"
                        onClick={onClose}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerificationPopup;
